/**
 * TEMP — Ashley Interface v1 STT pipeline debug logging.
 *
 * Remove this file and all imports after real-device validation.
 */
import { ASHLEY_DEBUG_ENABLED } from "./ashleyDebugConfig";

export const ASHLEY_STT_DEBUG = ASHLEY_DEBUG_ENABLED;

/** @param {...unknown} args */
export function ashleyLog(...args) {
  if (!ASHLEY_STT_DEBUG) {
    return;
  }
  console.log("[Ashley]", ...args);
}

/** @param {...unknown} args */
export function ashleyWarn(...args) {
  if (!ASHLEY_STT_DEBUG) {
    return;
  }
  console.warn("[Ashley]", ...args);
}
